export default __webpack_public_path__ + "static/outrider-bombblast-sm-980913e7180cf12410b6a6ab0ccc39d1.mp4";